(function () {
  'use strict';

  // ── Reading progress bar ───────────────────────────────────────────────
  function initProgressBar() {
    const bar = document.querySelector('.ce-progress');
    const article = document.querySelector('.ce-article');
    if (!bar || !article) return;
    let ticking = false;
    function update() {
      const rect = article.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const progress = total > 0 ? Math.max(0, Math.min(1, -rect.top / total)) : 0;
      bar.style.transform = 'scaleX(' + progress + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // ── TOC builder (Guide rubric) ─────────────────────────────────────────
  function initTocBuilder() {
    const body = document.querySelector('.ce-body--guide');
    const tocList = document.querySelector('.ce-guide__toc-list');
    const tocMobileList = document.querySelector('.ce-guide__toc-drawer-list');
    const tocBlock = document.querySelector('.ce-guide__toc');
    if (!body || !tocList) return;

    const slugify = function (s) {
      return s.toLowerCase().trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 60);
    };
    const headings = body.querySelectorAll('h2');
    if (!headings.length) {
      if (tocBlock) tocBlock.style.display = 'none';
      return;
    }
    const used = new Set();
    headings.forEach(function (h, i) {
      if (!h.id) {
        let slug = slugify(h.textContent || ('section-' + (i + 1)));
        let unique = slug;
        let n = 2;
        while (used.has(unique)) { unique = slug + '-' + n++; }
        used.add(unique);
        h.id = unique;
      } else {
        used.add(h.id);
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      if (i === 0) li.classList.add('active');
      tocList.appendChild(li);
      if (tocMobileList) tocMobileList.appendChild(li.cloneNode(true));
    });
  }

  // ── Mobile TOC drawer (Guide rubric) ──────────────────────────────────
  function initTocDrawer() {
    const pill = document.querySelector('.ce-guide__toc-mobile-pill');
    const drawer = document.querySelector('.ce-guide__toc-drawer');
    const backdrop = document.querySelector('.ce-guide__toc-drawer-backdrop');
    const close = document.querySelector('.ce-guide__toc-drawer-close');
    if (!pill || !drawer) return;
    const open = function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const dismiss = function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    pill.addEventListener('click', open);
    if (backdrop) backdrop.addEventListener('click', dismiss);
    if (close) close.addEventListener('click', dismiss);
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') dismiss();
    });
  }

  // ── Drop cap wrap (Editorial rubric) ──────────────────────────────────
  function initDropCap() {
    const body = document.querySelector('.ce-body--editorial');
    if (!body) return;
    const firstP = body.querySelector('p');
    if (!firstP || !firstP.textContent.trim()) return;
    // Walk text nodes to find the first character (skipping leading inline tags' text)
    const walker = document.createTreeWalker(firstP, NodeFilter.SHOW_TEXT, null);
    const first = walker.nextNode();
    if (!first || !first.textContent.length) return;
    const ch = first.textContent[0];
    const rest = first.textContent.slice(1);
    const span = document.createElement('span');
    span.className = 'ce-dropcap';
    span.textContent = ch;
    first.textContent = rest;
    first.parentNode.insertBefore(span, first);
  }

  // ── Newsletter mid-article insertion ──────────────────────────────────
  function initNewsletterInsert() {
    const slot = document.querySelector('.ce-newsletter-mid-slot');
    const template = document.querySelector('#ce-newsletter-template');
    const body = document.querySelector('.ce-body');
    if (!slot || !template || !body) return;
    // Only count H2s that are direct section breaks — skip those inside
    // .ce-trend-item or .ce-faq (those wrap special semantic units).
    const headings = Array.from(body.querySelectorAll('h2')).filter(function (h) {
      return !h.closest('.ce-trend-item') && !h.closest('.ce-faq');
    });
    if (headings.length < 3) return; // not enough body to warrant mid-article placement
    // Insert BEFORE the middle H2 — this places newsletter between previous
    // section's body and next section's heading (clean break, doesn't split
    // any heading from its body paragraph).
    const targetIndex = Math.floor(headings.length / 2);
    const target = headings[targetIndex];
    if (!target || !target.parentNode) return;
    const inst = template.content.cloneNode(true);
    target.parentNode.insertBefore(inst, target);
  }

  // ── Share copy link ───────────────────────────────────────────────────
  function initShareCopyLink() {
    document.querySelectorAll('.ce-share__copy').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const url = window.location.href;
        const copiedText = btn.dataset.copiedText || 'Copied';
        const originalAria = btn.getAttribute('aria-label') || '';
        const setLabel = function (label) {
          btn.setAttribute('aria-label', label);
          const visuallyHidden = btn.querySelector('.visually-hidden');
          if (visuallyHidden) visuallyHidden.textContent = label;
        };
        const restore = function () {
          setLabel(originalAria);
          btn.classList.remove('is-copied');
        };
        const handleSuccess = function () {
          setLabel(copiedText);
          btn.classList.add('is-copied');
          setTimeout(restore, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(handleSuccess);
        } else {
          // Fallback: select a hidden textarea
          const ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed'; ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.focus(); ta.select();
          try { document.execCommand('copy'); handleSuccess(); } catch (_) {}
          document.body.removeChild(ta);
        }
      });
    });
  }

  // ── Newsletter form: enable submit only when consent + email valid ────
  function initNewsletterForm() {
    document.querySelectorAll('.ce-newsletter-form').forEach(function (form) {
      const submit = form.querySelector('button[type="submit"]');
      const consent = form.querySelector('input[name="$consent"]');
      const email = form.querySelector('input[type="email"]');
      if (!submit || !consent || !email) return;
      const update = function () {
        submit.disabled = !(consent.checked && email.value && email.checkValidity());
      };
      consent.addEventListener('change', update);
      email.addEventListener('input', update);
      update();
    });
  }

  // ── Product strip scroll affordance ───────────────────────────────────
  function initProductStripScroll() {
    document.querySelectorAll('.ce-pm-strip').forEach(function (strip) {
      const track = strip.querySelector('.ce-pm-strip__track');
      const hint = strip.querySelector('.ce-pm-strip__hint');
      if (!track || !hint) return;
      hint.addEventListener('click', function () {
        // Scroll right by ~60% of track viewport width
        track.scrollBy({ left: Math.max(track.clientWidth * 0.6, 200), behavior: 'smooth' });
      });
      // Hide hint when scrolled to or near end
      function updateHintVisibility() {
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        hint.style.opacity = atEnd ? '0' : '0.85';
        hint.style.pointerEvents = atEnd ? 'none' : 'auto';
      }
      track.addEventListener('scroll', updateHintVisibility, { passive: true });
      updateHintVisibility();
    });
  }

  // ── Init all ──────────────────────────────────────────────────────────
  function init() {
    initProgressBar();
    initTocBuilder();
    initTocDrawer();
    initDropCap();
    initNewsletterInsert();
    initShareCopyLink();
    initNewsletterForm();
    initProductStripScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
